import { RouteType } from "types/RouteType";
import { routesWithAuth } from "../stores/RouterStore/authRoutes";
import adminRoutesList from "./admin/adminRoutesList";
import crmRoutesList from "./crm/crmRoutesList";
import productRoutesList from "./product/productRoutesList";
import dispatchRoutesList from "./dispatch/dispatchRoutesList";
import productionRoutesList from "./production/productionRoutesList";
import operationsRoutesList from "./operations/operationsRoutesList";
import schedulingRoutesList from "./scheduling/schedulingRoutesList";
import qualityControlRoutesList from "./qualityControl/qualityControlRoutesList";
import dashboardsRoutesList from "./dashboards/dashboardsRoutesList";
import inventoryAndFieldRoutesList from "./inventoryAndField/inventoryAndFieldRoutesList";
import inventoryRoutesList from "./inventory/inventoryRoutesList";
import yardManagementRoutesList from "./yardManagement/yardManagementRoutesList";
import projectManagementRoutesList from "./projectManagement/projectManagementRoutesList";
import administrationRoutesList from "./administration/administrationRoutesList";
import settingsRoutesList from "./settings/settingsRoutesList";
import estimatingRoutesList from "./estimating/estimatingRoutesList";
import salesRoutesList from "./sales/salesRoutesList";
import purchasingRoutesList from "./purchasing/purchasingRoutesList";
import QuoteToProductionRoute from "./purchasing/quote-conversion/QuoteToProduction.Route";
import BomImportRoute from "./purchasing/bom-import/BomImport.Route";
import MaterialsRoute from "./materials/Materials.Route";
import fieldReportingRoutesList from "./fieldReporting/fieldReportingRoutesList";
import workflowsRoutesList from "./workflows/workflowsRoutesList";
import PdfEditorRoute from "./pdf/editor/PdfEditor.Route";
import PdfManagementRoute from "./pdf/management/PdfManagement.Route";
import BomExtractionRoute from "./bom-extraction/BomExtraction.Route";
import payrollRoutesList from "./payroll/payrollRoutesList";
import { generateServiceViewRoutes } from "../stores/RouterStore/utils/ServiceViewRouteGenerator";
import { isServiceViewVisible } from "./serviceViewPolicy";
import serviceStores from "../serviceStoresConfig";

// Generate dynamic service view routes
// The generator emits one "<Title> Management" route per service store with
// serviceView enabled — 27 of them, all landing on a screen that cannot load
// data (see serviceViewPolicy). Hidden rather than dropped, so the routes stay
// reachable by name and URL while leaving the menu and omnibar to the fifteen
// screens NTX actually uses.
const serviceViewRoutes = generateServiceViewRoutes(serviceStores).map(
  (route) => {
    const serviceName = String(route.path ?? "").replace(
      "/management/data/",
      "",
    );
    return isServiceViewVisible(serviceName)
      ? route
      : { ...route, hidden: true };
  },
);

const routesList: RouteType[] = [
  ...routesWithAuth,
  // // ...adminRoutesList,
  // // ...crmRoutesList,
  // // ...productRoutesList,
  // // ...dispatchRoutesList,
  // ...productionRoutesList,
  // ...operationsRoutesList,
  ...schedulingRoutesList,
  ...inventoryRoutesList, // @intrasync/inventory-management hub route
  ...qualityControlRoutesList, // @intrasync/quality-control hub + capture routes
  ...dashboardsRoutesList, // Executive + Plant Operations management dashboards
  // // ...inventoryAndFieldRoutesList,
  ...yardManagementRoutesList,
  // // ...projectManagementRoutesList,
  // ...administrationRoutesList,
  // ...settingsRoutesList,
  // ...salesRoutesList,
  ...estimatingRoutesList,
  // ...purchasingRoutesList,
  // QuoteToProductionRoute,
  // BomImportRoute,
  // MaterialsRoute,
  // ...fieldReportingRoutesList,
  // ...workflowsRoutesList,
  // ...payrollRoutesList,
  // PdfManagementRoute,
  // PdfEditorRoute,
  // BomExtractionRoute,
  ...serviceViewRoutes, // Add generated service view routes
];

export default routesList;
